import React from 'react';

const LockClosedOutline = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 21" {...props}>
    <path
      fillRule="evenodd"
      d="M14 7c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h1V5c0-2.76 2.24-5 5-5s5 2.24 5 5v2h1zM5 7h6V5c0-1.71-1.29-3.1-3-3.1S5 3.29 5 5v2zM2 9v10h12V9H2zm5 2.99c0-.546.444-.99 1-.99a1 1 0 0 1 1 .99v4.02c0 .546-.444.99-1 .99a1 1 0 0 1-1-.99v-4.02z"
    />
  </svg>
);

export default LockClosedOutline;
